// src/services/authService.js
import { configuredAxios as api } from './axiosConfig'; // ajuste o caminho se necessário

const authService = {
  // Registro de usuário
  async register(userData) {
    try {
      const response = await api.post('/auth/registrar', userData);
      return response.data;
    } catch (err) {
      // AGORA: Apenas repassa a mensagem do erro já tratado pelo interceptor
      throw new Error(err.message || 'Erro ao realizar o registro');
    }
  },

  // Login
  async login(credentials) {
    try {
      const response = await api.post('/auth/login', credentials);
      return response.data; // { success, token, user }
    } catch (err) {
      // AGORA: Apenas repassa a mensagem do erro já tratado pelo interceptor
      throw new Error(err.message || 'Erro ao conectar com o servidor');
    }
  },

  // Recuperar senha
  async recuperarSenha(email) {
    try {
      const response = await api.post('/auth/recuperar-senha', { email });
      return response.data;
    } catch (err) {
      // AGORA: Apenas repassa a mensagem do erro já tratado pelo interceptor
      throw new Error(err.message || 'Erro ao solicitar recuperação de senha');
    }
  },

  // Redefinir senha via token
  async resetPassword(token, newPassword) {
    try {
      const response = await api.patch(`/auth/redefinir-senha/${token}`, { password: newPassword });
      return response.data;
    } catch (err) {
      // AGORA: Apenas repassa a mensagem do erro já tratado pelo interceptor
      throw new Error(err.message || 'Erro ao redefinir a senha');
    }
  },

  // Buscar dados do usuário logado
  async getMe() {
    try {
      const response = await api.get('/auth/me');
      return response.data;
    } catch (err) {
      // AGORA: Apenas repassa a mensagem do erro já tratado pelo interceptor
      throw new Error(err.message || 'Erro ao buscar dados do usuário');
    }
  },

  // Atualizar dados do usuário (nome, email, etc.)
  async updateUser(userData) {
    try {
      const response = await api.patch('/auth/atualizar-dados', userData);
      return response.data;
    } catch (err) {
      // AGORA: Apenas repassa a mensagem do erro já tratado pelo interceptor
      throw new Error(err.message || 'Erro ao atualizar perfil');
    }
  },

  // NOVA FUNÇÃO para atualizar o avatar
  async updateAvatar(avatarFile) {
    try {
      const formData = new FormData();
      formData.append('avatar', avatarFile);

      const response = await api.patch('/auth/atualizar-avatar', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (err) {
      throw new Error(err.message || 'Erro ao atualizar a foto de perfil');
    }
  },

  // Atualizar senha
  async updatePassword({ currentPassword, newPassword }) {
    try {
      const response = await api.patch('/auth/atualizar-senha', { currentPassword, newPassword });
      return response.data;
    } catch (err) {
      // AGORA: Apenas repassa a mensagem do erro já tratado pelo interceptor
      throw new Error(err.message || 'Erro ao atualizar senha');
    }
  }
};

export default authService;